export enum RightSidebarModuleName {
    NOTIFY = 'notify',
    SHORTCUT = 'shortcut_panel',
    READ_RECORD = 'read-record',
    HISTORY = 'history',
}
